var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Collapse from 'antd/lib/collapse';
import Radio from 'antd/lib/radio';
import BoxModel from './common/BoxModel';
var Panel = Collapse.Panel;
var RadioButton = Radio.Button;
var RadioGroup = Radio.Group;
var EditorBorder = /** @class */ (function (_super) {
    __extends(EditorBorder, _super);
    function EditorBorder(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (e, isDrag) {
            var _a;
            var value = __assign(__assign({}, _this.props.value), (_a = {}, _a[_this.state.key] = e, _a));
            _this.props.onChange('border', value, isDrag);
        };
        _this.getTabs = function () { return (React.createElement(RadioGroup, { value: _this.state.key, onChange: _this.radioChange, size: "small" }, Object.keys(_this.props.locale.tags).map(function (key) { return (React.createElement(RadioButton, { value: key, key: key, className: "ant-radio-button-auto-width" }, _this.props.locale.tags[key])); }))); };
        _this.radioChange = function (e) {
            _this.setState({
                key: e.target.value,
            });
        };
        _this.keys = ['top', 'right', 'bottom', 'left', 'center'];
        _this.state = {
            key: 'width',
        };
        return _this;
    }
    EditorBorder.prototype.render = function () {
        var _this = this;
        var props = __rest(this.props, []);
        var value = props.value, locale = props.locale;
        var key = this.state.key;
        ['value', 'onChange'].map(function (str) { return delete props[str]; });
        return (React.createElement(Panel, __assign({}, props, { header: props.header || locale.header }),
            this.getTabs(),
            React.createElement(BoxModel, { name: key, key: key, keys: this.keys, value: value[key], onChange: function (v, isDrag) {
                    _this.onChange(v, isDrag);
                } })));
    };
    EditorBorder.propTypes = {
        value: PropTypes.object,
        onChange: PropTypes.func,
        header: PropTypes.string,
        locale: PropTypes.object,
    };
    EditorBorder.defaultProps = {
        value: {
            style: 'none',
            color: '#000',
            width: null,
            radius: null,
        },
        onChange: function () {
        },
    };
    return EditorBorder;
}(Component));
export default EditorBorder;
EditorBorder.componentName = 'EditorBorder';
